import OImage from 'components/reusable/OImage'
import { isEmpty } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

function Address ({ items }) {
  const generateMapURL = property => {
    if (isEmpty(property.location)) return ''
    const baseURL = 'https://www.google.com/maps?q='
    const propertyLocation = [
      property.location.coordinates[1],
      property.location.coordinates[0]
    ]
    return `${baseURL}${propertyLocation.join(',')}`
  }
  const { t } = useTranslation()
  return (
    <>
      <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
        <tbody>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('O_CITY')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.city?.name}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('O_COMMUNITY')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.community?.name}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('O_SUB_COMMUNITY')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.subCommunity?.name}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('UNIT_NUMBER')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.unitNumber}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('STREET')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.street}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('BUILDING')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.building}
            </th>

          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('O_NEAREST_FACILITIES')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {Array.isArray(items?.nearestFacility) && items?.nearestFacility?.length > 0 ? items?.nearestFacility?.map((val, ind) => <span key={ind}>{val}, </span>) : 'N/A'}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {t('O_NEAREST_FACILITIES') + t('O_ARABIC')}
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {Array.isArray(items?.nearestFacilityAr) && items?.nearestFacilityAr?.length > 0 ? items?.nearestFacilityAr?.map((val, ind) => <span key={ind}>{val}, </span>) : 'N/A'}
            </th>
          </tr>

        </tbody>
      </table>
      <div className=''>
        <div className='text-50px font-medium text-lg p-6 pb-0'>Location</div>
        {items?.locationImage
          ? (
            <div className='mb-4 pl-6 pr-4 flex flex-wrap'>
              <a href={generateMapURL(items)} target='_blank' rel='noreferrer'>
                <OImage
                  height={350}
                  src={items?.locationImage}
                  className='w-full'
                  alt='image'
                />
              </a>
            </div>
            )
          : (
            <div className='flex justify-center items-center'>Not found</div>
            )}
      </div>
    </>
  )
}

export default Address
